import * as React from "react";

export default function CookiePolicy() {
  return (
    <main className="container mx-auto max-w-3xl px-4 py-10">
      <div 
        className="rounded-xl border bg-white p-6 shadow-sm" 
        style={{ marginTop: "120px" }}
      >
        <h1 className="heading-1 mb-2">Cookie Policy</h1>
        <p className="body-small text-gray-600">Last updated: [December, 2025]</p>

        <div className="mt-6 space-y-4 text-sm leading-6 text-gray-700">
          <p>
            This website uses cookies to improve your browsing experience, analyze site traffic, 
            and understand where our visitors are coming from.
          </p>
          <p>
            You can manage or reject cookies directly in your browser settings. 
            By continuing to browse, you consent to our use of cookies.
          </p>
        </div>
      </div>
    </main>
  );
}
